/**
 * Checks if the format string contains date-related tokens.
 */
export function containsDateFormat(format: string) {
  return !!format.match(/[yYMLDdEe]+/);
}
